import styled from 'styled-components';

export const NavBlock = styled.div`
  width: 162px;
  height: 326px;
  z-index: 1;

  > .bg-img-wrapper {
    position: absolute;
    top: -4px;
    bottom: 0;
    left: -5px;
    right: 0;
    z-index: -1;
    > .bg-img {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: 17px;
  /* > .bg-img-wrapper {
    position: absolute;
    top: -4px;
    bottom: 0;
    left: -5px;
    right: 0;
    z-index: -1;
    > .bg-img {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  } */

  > .title {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: default;
    > .title-text {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(19, 238, 179, 1);
      text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.44);
      display: block;
      margin-left: auto;
    }
    > .arrow-up {
      margin-left: 7px;
      margin-right: 20px;

      width: 8px;
      height: 5px;
      display: block;
    }
  }
`;

export const MenuFloor = styled.div`
  height: 41px;
  display: flex;
  width: 100%;
  align-items: center;

  border-bottom: 1px solid rgba(19, 238, 179, 0.1);
  > .item {
    height: 100%;

    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.6);
    position: relative;
    z-index: 1;
    cursor: pointer;

    &:not(:first-child) {
      margin-left: 33px;
    }

    &.active {
      color: rgba(51, 255, 200, 1);
      &::before {
        content: '';
        display: block;
        position: absolute;
        width: 20px;
        height: 3px;
        background: rgba(19, 238, 179, 1);
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        transform: translateY(50%);
      }
    }
  }
`;

export const LinkBLockWrapper = styled.div`
  padding-top: 18px;
  padding-bottom: 18px;
  box-sizing: border-box;
  height: 252px;
`;
export const LinkBlock = styled.div`
  overflow-y: scroll;
  height: 100%;

  /*控制整个滚动条*/
  ::-webkit-scrollbar {
    background-color: rgba(77, 148, 129, 1);
    width: 3px;
    /* height: 10px; */
    background-clip: padding-box;
  }

  /*滚动条两端方向按钮*/
  ::-webkit-scrollbar-button {
    background-color: rgba(19, 238, 179, 1);
  }

  /*滚动条中间滑动部分*/
  ::-webkit-scrollbar-thumb {
    background-color: rgba(19, 238, 179, 1);
    border-radius: 5px;
  }

  /*滚动条右下角区域*/
  ::-webkit-scrollbar-corner {
    background-color: rgba(19, 238, 179, 1);
  }
`;

export const Link = styled.div`
  height: 36px;
  line-height: 36px;
  display: block;

  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);

  &:hover {
    /* color: rgba(255, 255, 255, 1); */
    text-decoration: underline;
    color: rgba(27, 252, 191, 1);
  }
`;
